import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const MicrophoneIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="
          M18 28.125
          a9 9 0 0 0 9-9v-2.25
          m-9 11.25
          a9 9 0 0 1-9-9v-2.25
          m9 11.25v5.625
          m-5.625 0h11.25
          M18 23.625
          a4.5 4.5 0 0 1-4.5-4.5V6.75
          a4.5 4.5 0 1 1 9 0v12.375
          a4.5 4.5 0 0 1-4.5 4.5Z"
      />
    </SvgIcon>
  );
};

export default MicrophoneIcon;
